import { useMemo } from "react"

import { useWebAdminTranslationsQuery } from "@/queries/hooks"

const useWebAdminTranslations = () => {
  const { data: translations, isLoading } = useWebAdminTranslationsQuery()

  const t = useMemo(
    () => (key: string) => {
      if (isLoading) return ""
      return translations?.[key] ?? key
    },
    [translations, isLoading]
  )

  return { t, isLoading }
}

export default useWebAdminTranslations
